import {createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useCallback, useRef, useState,} from "react";
import {SupportTicketSingleDto} from "../API";

interface ICurrentSupportTicketContext {
    currentTicket?: SupportTicketSingleDto;
    setCurrentTicket: Dispatch<
        SetStateAction<SupportTicketSingleDto | undefined>
    >;
    reloadCurrentTicketTeamViewerSessions?: () => void;
    setReloadCurrentTicketTeamViewerSessions: (func: () => void) => void;
    reloadCurrentTicketCiscoPhoneSessions?: () => void;
    setReloadCurrentTicketCiscoPhoneSessions: (func: () => void) => void;
    reloadCurrentTicketTimeLogsSessions?: () => void;
    subscribeToReloadCurrentTicketTimeLogsSessions: (func: () => void) => void;
    unsubscribeFromReloadCurrentTicketTimeLogsSessions: (
        func: () => void,
    ) => void;
    subscribeToTimeLogSessionsPhaseChange: (
        func: (phase?: string) => void,
    ) => void;
    unsubscribeFromTimeLogSessionsPhaseChange: (
        func: (phase?: string) => void,
    ) => void;
    timeLogSessionsPhaseChange: (phase?: string) => void;
}

export const CurrentSupportTicketContext =
    createContext<ICurrentSupportTicketContext>({} as any);
export const CurrentSupportTicketContextEntry: FC<PropsWithChildren> = ({
                                                                            children,
                                                                        }) => {
    const [currentTicket, setCurrentTicket] = useState<SupportTicketSingleDto>();
    const reloadCurrentTicketTeamViewerSessions = useRef<() => void>();
    // const [reloadCurrentTicket, setReloadCurrentTicket] = useState<() => {}>();
    const reloadCurrentTicketCiscoPhoneSessions = useRef<() => void>();
    // const [reloadCurrentTicketCiscoPhoneSessions, setReloadCurrentTicketCiscoPhoneSessions] = useState<() => {}>();
    const reloadCurrentTicketTimeLogsSessions = useRef<(() => void)[]>([]);
    const timeLogSessionsPhaseChangeCallbacks = useRef<
        ((phase?: string) => void)[]
    >([]);

    const setReloadCurrentTicketTeamViewerSessions = useCallback(
        (func: () => void) => {
            reloadCurrentTicketTeamViewerSessions.current = func;
        },
        [],
    );

    const setReloadCurrentTicketCiscoPhoneSessions = useCallback(
        (func: () => void) => {
            reloadCurrentTicketCiscoPhoneSessions.current = func;
        },
        [],
    );

    const setReloadCurrentTicketTimeLogsSessions = useCallback(
        (func: () => void) => {
            if (reloadCurrentTicketTimeLogsSessions.current?.includes(func)) {
                return;
            } else {
                reloadCurrentTicketTimeLogsSessions.current = [
                    ...reloadCurrentTicketTimeLogsSessions.current,
                    func,
                ];
            }
        },
        [],
    );

    const reloadCurrentTicketTimeLogsSessionsWrapper = useCallback(() => {
        reloadCurrentTicketTimeLogsSessions.current?.forEach((func) => func());
    }, []);

    const unsetReloadCurrentTicketTimeLogsSessions = useCallback(
        (func: () => void) => {
            reloadCurrentTicketTimeLogsSessions.current =
                reloadCurrentTicketTimeLogsSessions.current?.filter((f) => f !== func);
        },
        [],
    );

    const subscribeToTimeLogSessionsPhaseChange = useCallback(
        (func: (phase?: string) => void) => {
            timeLogSessionsPhaseChangeCallbacks.current = [
                ...timeLogSessionsPhaseChangeCallbacks.current,
                func,
            ];
        },
        [],
    );

    const unsubscribeFromTimeLogSessionsPhaseChange = useCallback(
        (func: (phase?: string) => void) => {
            timeLogSessionsPhaseChangeCallbacks.current =
                timeLogSessionsPhaseChangeCallbacks.current.filter((f) => f !== func);
        },
        [timeLogSessionsPhaseChangeCallbacks],
    );

    const timeLogSessionsPhaseChange = useCallback((phase?: string) => {
        timeLogSessionsPhaseChangeCallbacks.current.forEach((func) => func(phase));
    }, []);

    return (
        <CurrentSupportTicketContext.Provider
            value={{
                currentTicket,
                setCurrentTicket,
                reloadCurrentTicketTeamViewerSessions:
                reloadCurrentTicketTeamViewerSessions.current,
                setReloadCurrentTicketTeamViewerSessions,
                reloadCurrentTicketCiscoPhoneSessions:
                reloadCurrentTicketCiscoPhoneSessions.current,
                setReloadCurrentTicketCiscoPhoneSessions,
                reloadCurrentTicketTimeLogsSessions:
                reloadCurrentTicketTimeLogsSessionsWrapper,
                subscribeToReloadCurrentTicketTimeLogsSessions:
                setReloadCurrentTicketTimeLogsSessions,
                unsubscribeFromReloadCurrentTicketTimeLogsSessions:
                unsetReloadCurrentTicketTimeLogsSessions,
                timeLogSessionsPhaseChange,
                unsubscribeFromTimeLogSessionsPhaseChange,
                subscribeToTimeLogSessionsPhaseChange,
            }}
        >
            {children}
        </CurrentSupportTicketContext.Provider>
    );
};
